import { createElementBlock, openBlock, createElementVNode } from 'vue';

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Website Icons Button",
  viewBox: "0 0 100 100"
};

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M98.53 98.45a5.003 5.003 0 0 1-7.07 0L50 56.98 8.53 98.45a5.003 5.003 0 0 1-7.07 0 5.003 5.003 0 0 1 0-7.07l41.48-41.46L1.47 8.45a4.985 4.985 0 0 1 0-7.07 5.003 5.003 0 0 1 7.07 0L50 42.86 91.47 1.39a5.003 5.003 0 0 1 7.07 0 5.003 5.003 0 0 1 0 7.07L57.06 49.92l41.47 41.47a4.956 4.956 0 0 1 0 7.06Z",
      style: {"stroke-width":"0"}
    }, null, -1)
  ])))
}
const CloseIcon = { render: render };

export { CloseIcon as default, render };
